import type { UnknownAction } from '@reduxjs/toolkit';

import { resourceUpserters } from '../core';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';
import * as actions from './userInfoActions';
import { mkUserInfoStore, type UserInfoProps } from './userInfoTypes';

function reducer(
  state: QcsSyncResourceStore<UserInfoProps> = mkUserInfoStore(),
  action: UnknownAction,
): QcsSyncResourceStore<UserInfoProps> {
  switch (true) {
    case actions.getUserInfo.match(action):
      return state.set('isLoading', true);
    case actions.getUserInfoSuccess.match(action):
      return resourceUpserters.upsertResources(state, action.payload);
    case actions.getUserInfoFailure.match(action):
      return resourceUpserters.completeWithError(state, action.payload);
    default:
      return state;
  }
}

export default reducer;
